import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { getAdminProfile } from 'features/user/actions';
import { getUnreadMessage, getUnreadNotificationCount } from 'features/notification-inbox/actions';
import { login, logout } from 'features/auth/actions';
import { rehydrateToken } from 'features/auth/slice';
import { checkEmptyObject } from 'utils/functionality';
import { getRolePermissionsById } from 'features/permissions/actions';
import { setSelectedMenu } from 'features/menu/menuSlice';
import { identifyUser, clearAnalytics, trackEvent } from 'utils/analytics';

export const authListenerMiddleware = createListenerMiddleware();

// Automatically fetch user data when user becomes logged in
authListenerMiddleware.startListening({
  matcher: isAnyOf(rehydrateToken, login.fulfilled),
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState();

    // Only fetch data if logged in and user data is not already loaded
    const dispatch = listenerApi.dispatch;
    if (state.auth.isLoggedIn && !state.user.data?.id) {
      const response = await dispatch(getAdminProfile());
      dispatch(getUnreadNotificationCount());
      dispatch(getUnreadMessage());

      if (getAdminProfile.fulfilled.match(response)) {
        const userProfile = response.payload;
        if (userProfile && !checkEmptyObject(userProfile)) {
          identifyUser(userProfile);
          trackEvent('auth_session_started', {
            role_id: userProfile.role_id,
            method: login.fulfilled.match(action) ? 'login' : 'rehydrate',
          });
          const permissionsResponse = await dispatch(getRolePermissionsById(userProfile.role_id));
          if (getRolePermissionsById.fulfilled.match(permissionsResponse)) {
            dispatch(setSelectedMenu(permissionsResponse.payload));
          }
        }
      }
    }
  },
});

authListenerMiddleware.startListening({
  matcher: isAnyOf(logout.fulfilled),
  effect: () => {
    trackEvent('auth_logout');
    clearAnalytics();
  },
});
